import chatScreenAssetsManager from "assets/assetsmanager/chatScreenAssetsManager";
import LikeDislike from "component/likeDislike/LikeDislike";
import useTranslateResponse from "hooks/useTranslateResponse";
import React, { useEffect, useRef, useState } from "react";
import { AiOutlineArrowRight } from "react-icons/ai";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkToc from "remark-toc";
import { condition } from "context/condition";
import { Globalstate } from "context/context";
import { IoIosArrowDown } from "react-icons/io";
import { nanoid } from "nanoid";
import { createBotMessage } from "utils/utils";

const BotText = ({
  className,
  isBingResponse,
  formattedAnswer,
  cta_results,
  answer,
  userMsg,
  responseId,
  isLastMessage,
  recommended_questions,
  isRecommendedQuestionClicked,
  messageKey,
  handleSubmit,
  setIsRecommendedQuestionClicked,
  handleTrackCtaClick,
  sourceCode,
  question,
  id,
  nudgeFlag,
  sources
}) => {
  const ref = useRef();

  const { mutateAsync: mutateAsyncTranslateQna } = useTranslateResponse();
  const [botAnswer] = useState({
    message: answer,
    language: "en-IN",
    languageName: "English"
  });
  const { state, dispatch } = Globalstate();

  const handleTranslateText = async (arr) => {
    const botKey = nanoid();
    const botMessage = createBotMessage("", botKey, "", [], [], "");
    dispatch({ type: condition.SETMESSGES, payload: botMessage });
    await mutateAsyncTranslateQna({
      ...arr,
      botKey: botKey,
      userMsg: question,
      id: id
    });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  const languageOptions = {
    English: "en-IN",
    Hindi: "hi-IN",
    Bengali: "bn-IN",
    Telugu: "te-IN",
    Tamil: "ta-IN",
    Kannada: "kn-IN",
    Malayalam: "ml-IN",
    Marathi: "mr-IN",
    Gujarati: "gu-IN",
    Urdu: "ur-IN",
    Punjabi: "pa-IN",
    Assamese: "as-IN",
    Odia: "or-IN",
    Maithili: "mai-IN",
    Dogri: "doi-IN",
    Kashmiri: "ks-IN",
    Bodo: "brx-IN"
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = ([language, code]) => {
    let arr = {
      ...botAnswer,
      text: answer,
      language: code,
      languageName: language,
      source_code: sourceCode ? sourceCode : "en-IN"
    };
    handleTranslateText(arr);
    setSelected(language);
    setIsOpen(false);
  };

  function getLanguageFromCode(code) {
    const codeToLanguage = Object.entries(languageOptions).reduce(
      (acc, [lang, code]) => {
        acc[code] = lang;
        return acc;
      },
      {}
    );
    return codeToLanguage[code] || "English";
  }

  const ctaLinkClick = (result, index) => {
    handleTrackCtaClick(responseId, index, result?.cta_name);
    console.log(
      `${!result?.cta_link?.includes("https://") ? "SIMPLIFI:::" : ""}${result?.cta_link
      }`
    );
    if (result?.cta_link?.includes("https://")) {
      window.open(result.cta_link, "_self");
    }
  };

  return (
    <div className={`bot-message-container ${className}`}>
      <div className="bot-message-text">
        {isLastMessage && (
          <div className="flex w-full justify-end">
            <div className="mr-1" ref={ref}>
              <button
                className="w-full bg-[#fff] border-[#ccc] cursor-pointer flex items-center gap-2 p-1.5 border rounded-md"
                onClick={toggleDropdown}
              >
                {!!selected ? selected : getLanguageFromCode(sourceCode)}{" "}
                <IoIosArrowDown />
              </button>
              {isOpen && (
                <div className=" absolute bg-[#fff] w-fit max-h-[145px] border border-[#ddd] z-[1] overflow-y-auto rounded-md mt-0.5">
                  {Object.entries(languageOptions).map(([language, code]) => (
                    <div
                      key={code}
                      className="p-[6px_10px] cursor-pointer hover:bg-[#f7d7d7]"
                      onClick={() => handleSelect([language, code])}
                    >
                      {language}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {isBingResponse && (
          <img
            className="bing-img-msg-label"
            src={chatScreenAssetsManager.bingSearchIcon}
            alt=""
          />
        )}{" "}
        {
          formattedAnswer?.length ?
            <Markdown
              remarkPlugins={[
                [remarkGfm],
                [remarkToc, { tight: true, maxDepth: 5 }]
              ]}
            >
              {formattedAnswer}
            </Markdown> : ''
        }
        {cta_results?.length > 0 && (
          <div className="bot-message-cta-button-container">
            {cta_results.map((result, index) => {
              return (
                <a
                  key={index}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ctaLinkClick(result, index);
                  }}
                >
                  <p>{result.cta_name}</p>
                  <div className="right-button-container">
                    <AiOutlineArrowRight />
                  </div>
                </a>
              );
            })}
          </div>
        )}
        <LikeDislike
          answer_type="answer"
          response={answer}
          query={userMsg}
          responseId={responseId}
          isBingResponse={isBingResponse}
          msgLikeDislike={true}
          isLastMessage={isLastMessage}
          messageKey={messageKey}
          nudgeFlag={nudgeFlag}
          sources={sources}
        />
      </div>
      {!isRecommendedQuestionClicked && recommended_questions?.length > 0 && (
        <div className="recommended-questions-container">
          <p className="recommended-question-header">
            Here are some more suggestions :
          </p>
          <div className="recommended-questions">
            {recommended_questions.map((question, index) => {
              return (
                <div
                  key={index}
                  className="bot-message-text"
                  onClick={() => {
                    if (state.source === "service") {
                      handleSubmit(question, true);
                    } else {
                      handleSubmit(question);
                    }
                    setIsRecommendedQuestionClicked(true);
                  }}
                >
                  <p>{question}</p>
                  <LikeDislike
                    answer_type={`question_${index + 1}`}
                    response={question}
                    query={userMsg}
                    responseId={responseId}
                    msgLikeDislike={false}
                    nudgeFlag={nudgeFlag}
                    sources={sources}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default BotText;
